import * as React from "react";

function SvgWoopra(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 256 152"
      preserveAspectRatio="xMidYMid"
      {...{ ...props, ref }}
    >
      <path d="M182.776 67.034l-16.614-21.556c15.659-17.093 36.59-23.804 56.795-16.46 20.364 7.402 33.91 26.808 33 48.245-.816 19.24-9.855 33.976-27.024 42.81-17.81 9.165-35.27 7.19-51.67-4.07-12.04-8.265-20.95-19.614-29.91-30.905-9.098-11.463-17.988-23.118-27.607-34.13-8.902-10.192-19.41-18.51-33.012-21.814-25.272-6.14-51.502 9.832-57.64 35.049-6.223 25.569 9.135 51.593 34.347 58.07 18.521 4.759 34.367-.882 47.94-13.378 7.728-7.116 14.645-15.114 22.208-23.007l17.356 21.693c-3.108 3.59-6.227 7.391-9.555 11-13.148 14.26-27.988 25.945-47.244 30.915C50.694 160.715 5.982 130.2.584 85.606-4.601 42.77 25.314 4.857 68.099.422c20.565-2.133 38.94 3.887 55.355 16.283 14.736 11.128 25.98 25.485 37.206 39.887 6.862 8.803 13.651 17.69 21.002 26.075 3.875 4.419 8.553 8.341 13.458 11.6 8.047 5.343 16.963 4.697 24.303-.84 7.029-5.302 10.263-14.422 8.101-22.85-2.232-8.705-9.674-15.368-18.616-16.563-5.447-.728-10.382.928-14.749 3.981-3.838 2.683-7.362 5.817-11.383 9.038" />
    </svg>
  );
}

export default React.forwardRef(SvgWoopra);
